module.exports = __webpack_public_path__ + "img/img90.08edd6ff.png";